export const load = () => ({
	title: 'Prevent Window Condensation',
	h1: 'Stop Condensation With Insulating Window Inserts',
	description:
		'Insulating window inserts stop mold and water damage from window condensation.',
	showTitle: true,
});
